import { render } from "./Slider.vue?vue&type=template&id=dd062360&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=dd062360&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dd062360"

export default script